export default __webpack_public_path__ + "static/media/arrow-right-white.f5933b3d.svg";